import {
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    makeStyles, Typography,
} from "@material-ui/core";

import React from 'react'

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
  },
  img: {
    marginRight: theme.spacing(1),
    width: 40,
  },
    text: {
      maxWidth: "70%"
    }
}));

function Song({ track, action }) {
    const classes = useStyles();

    return (
        <ListItem>
            <img
                src={track.album_cover}
                alt={"Album Cover"}
                className={classes.img}
            />
            <ListItemText
                primary={track.title}
                secondary={
                    <React.Fragment>
                        <Typography variant="body2">{track.artists == null ? "" : track.artists.toString()}</Typography>
                        <Typography variant="body2">{track.requested_by && track.requested_by.length > 0 ? "Requested By: " + track.requested_by : ""}</Typography>
                    </React.Fragment>
                }
                disableTypography
                className={classes.text}
            />
            <ListItemSecondaryAction>{action}</ListItemSecondaryAction>
        </ListItem>
    );
}
export default Song;
